import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
} from '@angular/core';
import {ConfiguratorTableService, FieldTable, SqlProcessingLoadConf, Table,} from '@tj/tj-dmp-lib-api';
import {SelectItemGroup} from 'primeng/api';
import {FieldMapping} from '../field-mapping.interface';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'dmp-selector-field-table',
    templateUrl: './selector-field-table.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SelectorFieldTableComponent implements OnInit, OnChanges {
    constructor(protected tableResourceService: ConfiguratorTableService,
                protected changeDetectorRef: ChangeDetectorRef) {
    }

    @Input() tenant: string;
    @Input() sqlLoadConf: SqlProcessingLoadConf;
    @Input() value: FieldMapping;
    @Input() updateFirstEmitter = false;
    @Input() disabled = false;
    @Input() onlyTable: string;
    @Input() onlyUtmFields = false;
    @Input() excludedDestinationKeys: string[] = [];
    @Input() isAuthorisedAdmin: boolean = false;

    @Output() valueChange = new EventEmitter<FieldMapping>();

    tables: Table[];
    groupedFields: SelectItemGroup[];
    selectedField: FieldMapping;

    public static getCategory(f: FieldTable) {
        // type
        switch (f.categoryField) {
            case 'TEXT':
                return 'Texte (' + f.type.replace('String', '') + ')';
            case 'CIVILITY':
                return 'Civilité (3)';
            /* case "NUMBER":
              return "Nombre"; */
            case 'DATE':
                return 'Date';
            case 'DATE_TIME':
                return 'Date et heure';
            case 'TIME':
                return 'heure';
            case 'IATA_CITY':
                return 'Ville (3)';
            case 'IATA_AIRPORT':
                return 'Aéroport (3)';
            case 'IATA_COUNTRY':
                return 'Pays IATA (3)';
            case 'CARRIER':
                return 'Compagnie (3)';
            case 'AFFILIATION':
                return 'Partenaire (10)';
            case 'LANG':
                return 'Langue (2)';
            case 'COUNTRY':
                return 'Pays (3)';
            case 'BOOLEAN':
                return 'Binaire';
            default:
                return null;
        }
    }

    public static getType(f: FieldTable) {
        switch (f.type) {
            case 'Boolean':
                return 'Binaire';
            case 'Date':
                return 'Date';
            case 'DateTime':
                return 'Date et heure';
            case 'Time':
                return 'Heure';
            case 'Int':
                return 'Nombre entier';
            case 'BigInt':
                return 'Nombre entier (big)';
            case 'Decimal_11_2':
                return 'Nombre décimale (123456789,01)';
            case 'Decimal_5_2':
                return 'Nombre décimale (123,45)';
            case 'Decimal_8_2':
                return 'Nombre décimale (123456,78)';
            case 'String10':
                return 'Texte (10)';
            case 'String100':
                return 'Text (100)';
            case 'String25':
                return 'Texte (25)';
            case 'String255':
                return 'Texte (255)';
            case 'String3':
                return 'Texte (3)';
            case 'String50':
                return 'Texte (50)';
            case 'TEXT':
                return 'Long text';
            case 'UUID':
                return 'UUID';
            default:
                return '?' + f.code;
        }
    }

    private static getCatOrType(f: FieldTable) {
        let res = SelectorFieldTableComponent.getCategory(f);
        if (res == null) {
            res = SelectorFieldTableComponent.getType(f);
        }
        return res;
    }

    ngOnInit() {
        this.tableResourceService
            .getTablesUsingGET(this.tenant, this.sqlLoadConf.destTable)
            .subscribe((tables) => {
                this.tables = tables;
                // garde uniquement une table
                if (this.onlyTable) {
                    this.tables = this.tables.filter(
                        (t) => t.code === this.onlyTable
                    );
                } else {
                    this.tables = this.tables.filter(
                        (t) =>
                            t.tableDependencies.findIndex(
                                (td) => td.cardinalie === '0n01'
                            ) === -1
                    );
                }
                this.rebuildGroupedFields();
                if (this.value) {
                    this.groupedFields.forEach((g) => {
                        const find = g.items.find(
                            (f) =>
                                f.value.fieldDest === this.value.fieldDest &&
                                f.value.tableDest === this.value.tableDest
                        );
                        if (find) {
                            this.selectedField = find.value;
                            if (this.disabled) {
                                this.update();
                            }
                            this.changeDetectorRef.detectChanges();
                        }
                    });
                }
                // this.updateValue();
            });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.tables && (changes.value || changes.excludedDestinationKeys || changes.onlyUtmFields || changes.onlyTable)) {
            this.rebuildGroupedFields();
            if (this.value && this.selectedField?.fieldDest && this.selectedField?.tableDest) {
                const selectedStillAvailable = this.groupedFields.some((g) =>
                    g.items.some((i) =>
                        i.value.fieldDest === this.selectedField.fieldDest &&
                        i.value.tableDest === this.selectedField.tableDest
                    )
                );
                if (!selectedStillAvailable) {
                    this.selectedField = this.value;
                }
            }
            this.changeDetectorRef.detectChanges();
        }
    }

    private updateValue() {
        if (this.value) {
            this.selectedField = this.value;
            this.updateListField(this.updateFirstEmitter);
        } else {
            this.selectedField = null;
        }
        this.changeDetectorRef.detectChanges();
    }

    updateListField(updateEmitter = true) {
        // changement par l'utilisteur de la table
        // if(updateEmitter){
        // }
        // mise à jour de la liste des champs de table

        if (updateEmitter) {
            this.update();
        }
    }

    updateField() {
        console.log(this.selectedField);
        this.update();
    }

    update() {
        let field = null;
        if (
            this.tables &&
            this.selectedField.fieldDest &&
            this.selectedField.tableDest
        ) {
            const table = this.tables.find(
                (i) => i.code === this.selectedField.tableDest
            );
            field = table.fields.find(
                (i) => i.code === this.selectedField.fieldDest
            );
        }

        this.valueChange.emit({
            fieldDest: this.selectedField.fieldDest,
            tableDest: this.selectedField.tableDest,
            field,
        });
    }

    /**
     * Détermine si un champ doit être inclus dans la liste des champs disponibles pour la sélection
     * @param field Le champ à évaluer
     * @returns true si le champ doit être affiché dans le sélecteur, false sinon
     */
    private shouldIncludeField(field: FieldTable): boolean {
        const includeBasicConditions = !field.pk && !field.fk && !field.autoIncrement && field.categoryField !== 'TECHNICAL';
        const visible = !(this.isAuthorisedAdmin === false && field.adminOnly === true);
        return includeBasicConditions && visible;
    }

    private rebuildGroupedFields(): void {
        const excluded = new Set(this.excludedDestinationKeys || []);
        this.groupedFields = (this.tables || []).map((t) => {
            const fields = t.fields
                .filter((f) => this.shouldIncludeField(f))
                .filter((f) => !this.onlyUtmFields || this.isUtmFieldCode(f.code))
                .filter((f) => {
                    const key = this.getDestinationKey(t.code, f.code);
                    const isCurrentValue =
                        this.value?.tableDest === t.code && this.value?.fieldDest === f.code;
                    return isCurrentValue || !excluded.has(key);
                })
                .map((f) => {
                    if (f.label) {
                        return {
                            label: `${f.label} - ${SelectorFieldTableComponent.getCatOrType(
                                f
                            )}`,
                            value: { fieldDest: f.code, tableDest: t.code },
                        };
                    } else {
                        return {
                            label: `${f.code} - ${SelectorFieldTableComponent.getCatOrType(
                                f
                            )}`,
                            value: { fieldDest: f.code, tableDest: t.code },
                        };
                    }
                });
            return { label: `Table ${t.code}`, items: fields };
        });
    }

    private getDestinationKey(tableDest: string, fieldDest: string): string {
        return `${(tableDest || '').toLowerCase()}::${(fieldDest || '').toLowerCase()}`;
    }

    private isUtmFieldCode(code: string): boolean {
        const c = (code || '').toLowerCase();
        return ['provider_source', 'provider_medium', 'provider_campaign', 'provider_term', 'provider_content'].includes(c);
    }

}
